import { IconButton, Tooltip, TooltipProps, styled, tooltipClasses } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import DownloadIcon from "../assets/icons/DownloadIcon";
import { useAppDispatch } from "../hooks/sharedHooks";
import colors from "../themes/colors";

interface DownloadOfferProps {
  item: any;
  request: (id: string) => any;
  title: string;
}

export const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: colors.secondary.gray20,
    color: colors.primary.white1
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: colors.secondary.gray20
  }
}));

const DownloadFile = ({ item, title, request }: DownloadOfferProps) => {
  const dispatch = useAppDispatch();

  const handleDownloadDocument = async (event: any, item: any) => {
    event.stopPropagation();
    const result = await dispatch(request(item.id));
    if (result?.payload) {
      download(result.payload);
    }
  };

  const download = (file: any) => {
    const downloadURL = URL.createObjectURL(file.data);
    const link = document.createElement("a");
    const fileName = file.headers.get("content-disposition").split("''").pop();
    link.href = downloadURL;
    link.target = "_blank";
    link.download = `${fileName}.pdf`;
    link.click();
    link.remove();
  };

  return (
    <Box>
      {item?.documentFile && (
        <Box className="flex justify-center">
          <CustomTooltip
            title={
              <Box className="text-12-bold" color={colors.primary.white1} sx={{ width: "72px" }}>
                {title}
              </Box>
            }
            arrow
            placement="top"
            className="download-icon"
          >
            <IconButton onClick={(event) => handleDownloadDocument(event, item)}>
              <DownloadIcon />
            </IconButton>
          </CustomTooltip>
        </Box>
      )}
    </Box>
  );
};
export default DownloadFile;
